import { motion } from "framer-motion";

const METRICS = [
  { label: "Dossiers accompagnés*", value: "12 500+", testid: "metric-clients" },
  { label: "Assureurs comparés", value: "40+", testid: "metric-partners" },
  { label: "Clients satisfaits*", value: "98,4 %", testid: "metric-satisfaction" },
  { label: "Économie moyenne constatée*", value: "28 %", testid: "metric-savings" },
];

export default function Metrics() {
  return (
    <section data-testid="metrics-section" className="border-y hairline bg-slate2/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 py-16 sm:py-20 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {METRICS.map((m, i) => (
          <motion.div
            key={m.label}
            data-testid={m.testid}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="text-center lg:text-left"
          >
            <p className="font-serif text-5xl sm:text-6xl font-semibold text-amber">{m.value}</p>
            <p className="mt-3 font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] text-ivory/50">
              {m.label}
            </p>
          </motion.div>
        ))}
      </div>
      <p
        data-testid="metrics-footnote"
        className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 pb-8 -mt-4 font-mono text-[10px] uppercase tracking-[0.18em] text-ivory/35 text-center lg:text-left"
      >
        * Expérience cumulée de l'équipe, acquise dans le courtage en assurance depuis 2009
      </p>
    </section>
  );
}
